<template>
    <v-container>
      <h1>Acceso denegado</h1>
      <p>No tienes los permisos necesarios para acceder a esta página.</p>
      <v-btn @click="$router.push('/')" color="primary">Volver a vista Principal</v-btn>
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'Unauthorized',
  };
  </script>